import React from 'react';
type BadgeVariant = 'hit' | 'new' | 'sale' | 'top' | 'default';
interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}
const variantStyles: Record<BadgeVariant, string> = {
  hit: 'bg-orange-500 text-white',
  new: 'bg-emerald-500 text-white',
  sale: 'bg-red-500 text-white',
  top: 'bg-sky-500 text-white',
  default: 'bg-slate-200 text-slate-700'
};
export function Badge({
  children,
  variant = 'default',
  className = ''
}: BadgeProps) {
  return <span className={`
        inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-semibold
        ${variantStyles[variant]}
        ${className}
      `} data-id="element-310">
      {children}
    </span>;
}
export function getBadgeVariant(badge: string | undefined): BadgeVariant {
  switch (badge) {
    case 'Хіт продажів':
      return 'hit';
    case 'Новинка':
      return 'new';
    case 'Знижка':
      return 'sale';
    case 'Топ':
      return 'top';
    default:
      return 'default';
  }
}